import {PollDetails, PollCard} from './Poll';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import MicroIcon from '../shared/MicroIcon';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.CARD_POLL);

export const card = PollCard;
export const details = PollDetails;
export const micro = Micro;
export const icon = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = PollCard;
